module.exports = __webpack_public_path__ + "img/icon_djyl .d7fca9aa.png";